export default "__VITE_ASSET__DGE0KbG7__"